import { CheckCircle } from "lucide-react";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getProsecutorDetailByEmployeeId, getProsecutorListByAdminUnitAndOrgUnit } from "app/apis/users";
import { filterUsersByEmployeeId } from "app/utils/custom_functions";
import { useTranslation } from "react-i18next";

const EmployeeProfile = ({ request }) => {
  const { t } = useTranslation();
  const [userDetail, setUserDetail] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!request) return;

    const fetchEmployeeDetail = async () => {
      try {
        const response = await getProsecutorDetailByEmployeeId(request);
        setUserDetail(response?.data);
      } catch (error) {
        setError(error.message || t('Failed to fetch employee details'));
        console.error('Error fetching employee details:', error);
      }
    };

    fetchEmployeeDetail();
  }, [request]);

  return (
    <div className="flex items-center w-full bg-opacity-75" style={{}}>
      <div>
        <h2
          className="text-[18] font-semibold"
          style={{ color: "black", fontFamily: "Pretendard", fontSize: "18px" }}
        >
          {[
            userDetail?.employee_info?.first_name
              ? userDetail?.employee_info?.first_name
              : '',
            userDetail?.employee_info?.last_name
              ? userDetail?.employee_info?.last_name
              : ''
          ].filter(Boolean).join(' ')}
        </h2>
      </div>
    </div>
  );
};

export default EmployeeProfile;